import type { EventName } from "@lit/react";
import { DatePicker as DatePickerElement, type DatePickerEventMap as _DatePickerEventMap, } from "@vaadin/date-picker/vaadin-date-picker.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DatePickerElement, };
export type DatePickerEventMap = Readonly<{
    onValidated: EventName<_DatePickerEventMap["validated"]>;
    onChange: EventName<_DatePickerEventMap["change"]>;
    onInput: EventName<_DatePickerEventMap["input"]>;
    onOpenedChanged: EventName<_DatePickerEventMap["opened-changed"]>;
    onValueChanged: EventName<_DatePickerEventMap["value-changed"]>;
    onInvalidChanged: EventName<_DatePickerEventMap["invalid-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInput: "input", onOpenedChanged: "opened-changed", onValueChanged: "value-changed", onInvalidChanged: "invalid-changed" } as DatePickerEventMap;
export type DatePickerProps = WebComponentProps<DatePickerElement, DatePickerEventMap>;
export const DatePicker = createComponent({
    elementClass: DatePickerElement, events, react: React, tagName: "vaadin-date-picker"
});
